import Dashboard from './dashboard'
import Analytics from './analytics'

const modules = {
    Dashboard,
    Analytics
}

const state = {}

const mutations = {}
const actions = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    modules
}
